'use client';

import React from 'react';
import useSimpleApiHandler from '@frontend/jetlend-core/src/hooks/useSimpleApiHandler';
import LoaderBlock from '@frontend/jetlend-web-ui/src/ui/loaders/LoaderBlock';
import AchievementPopup from '@app/features/academy/achievement/AchievementPopup/AchievementPopup';
import { IBasePageApiModel } from '@app/models/common/pages';
import AuthorizedMainPage from './AuthorizedMainPage';
import GuestsMainPage from './GuestsMainPage';
import {
    IAcademySpeakerApiModel,
    ICourseInformationApiModel,
    IPromotionCourseApiModel,
} from '@app/models/features/course';
import { getAchievementsHandler } from '@app/ducks/academy/course';
import { accountInfoHandler } from '@app/ducks/common/account';

export interface IProps {
    /**
     * Доп поля страницы
     */
    pageModel: IBasePageApiModel;
    /**
     * Список всех курсов
     */
    courses: ICourseInformationApiModel[];
    /**
     * Список спикеров
     */
    speakers: IAcademySpeakerApiModel[];
    /**
     * Информация о рекламном курсе
     */
    promotionCourse: IPromotionCourseApiModel;
}

/**
 * Компонент для отображения главной страницы академии
 * @returns если пользователь залогинен страница с информацией пользователя, если нет страница для гостя
 *
 */
export default function AcademyMainPage({
    courses,
    promotionCourse,
    pageModel,
    speakers,
}: IProps) {
    const [account, isFetching] = useSimpleApiHandler(accountInfoHandler);
    const [achievements, isAchievementsFetching] = useSimpleApiHandler(getAchievementsHandler);
    const isLoading = !account && isAchievementsFetching || !achievements;

    if (isLoading) {
        return (
            <div className="h-height--full">
                <LoaderBlock size="xlarge" />
            </div>
        );
    }

    return (
        <>
            {account
                ? (
                    <AuthorizedMainPage
                        achievements={achievements}
                        courses={courses}
                        promotionCourse={promotionCourse}
                    />
                )
                : (
                    <GuestsMainPage
                        pageModel={pageModel}
                        achievements={achievements}
                        courses={courses}
                        speakers={speakers}
                        promotionCourse={promotionCourse}
                    />
                )
            }
            <AchievementPopup />
        </>
    );
}